var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutIt03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0488 35.4713L33.423 31.8455C34.0705 30.8096 34.459 29.5146 34.459 28.2197C34.459 24.5939 31.6102 21.7451 27.9844 21.7451C24.3586 21.7451 21.5098 24.5939 21.5098 28.2197C21.5098 31.8455 24.3586 34.6943 27.9844 34.6943C29.2793 34.6943 30.5742 34.3059 31.6102 33.6584L35.2359 37.2842L37.0488 35.4713ZM24.0996 28.2197C24.0996 26.0184 25.783 24.335 27.9844 24.335C30.1857 24.335 31.8691 26.0184 31.8691 28.2197C31.8691 30.4211 30.1857 32.1045 27.9844 32.1045C25.783 32.1045 24.0996 30.4211 24.0996 28.2197ZM8.56055 19.1553H21.5098V21.7451H8.56055V19.1553ZM8.56055 11.3857H24.0996V13.9756H8.56055V11.3857Z",
    fill: "#FF5B37",
    stroke: "#FAEEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3301 34.3059L9.59648 30.6801C5.71172 28.7377 3.38086 24.7234 3.38086 20.4502V3.61621H29.2793V17.8604H31.8691V3.61621C31.8691 2.1918 30.7037 1.02637 29.2793 1.02637H3.38086C1.95645 1.02637 0.791016 2.1918 0.791016 3.61621V20.4502C0.791016 25.7594 3.63984 30.5506 8.30156 33.0109L16.3301 37.2842V34.3059Z",
    fill: "#FF5B37",
    stroke: "#FAEEF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIt03);
export default __webpack_public_path__ + "static/media/about-it-03.c814145531d1b9563b257990c8ad392c.svg";
export { ForwardRef as ReactComponent };